import React from "react";
import ManualConnectionLauncher from "./ManualConversationConnectionScreen";
import { SessionCreatedCallback } from "../utils/sessionSetupFlows";
import { useSessionSetupFlow } from "../hooks/useSessionSetupFlows";
import { SessionSpec } from "../utils/sessionEndpoints";
import { useNavUtils } from "../utils/navUtils";

// The AI has convinced me that having this additional layer
// is good for 'separation of concerns' or some other bullshit.
const ManualConnectionWrapper: React.FC = () => {
  const { goNav } = useNavUtils();
  const { handleManualSessionSetup } = useSessionSetupFlow();

  const handleConnect = async (
    spec: SessionSpec,
    sessionCreatedCallback: SessionCreatedCallback,
    abortSignal?: AbortSignal
  ) => {
    try {
      await handleManualSessionSetup(spec, sessionCreatedCallback, abortSignal);
      goNav("/avatarstreamer", { extraParams: "devMode=true" });
    } catch (err) {
      console.error("Connection failed:", err);
      throw err;
    }
  };

  return <ManualConnectionLauncher onConnect={handleConnect} />;
};

export default ManualConnectionWrapper;
